module.exports = __webpack_public_path__ + "static/img/animales_12.21459957.jpg";